import { certaintyOrder, mosquitoStatus } from './mosquito-observations-sightings-list-item.constants'

const UNKNOWN_CERTAINTY_STATUS = { label: 'UNKNOWN', color: '#9ca3af' }

const normalizeCertaintyValue = (value) => {
  if (value === null || value === undefined) return null

  if (typeof value === 'object') {
    const key = Object.keys(value).find(k => k.endsWith('_certainty_category'))

    return value?.[key] ?? null
  }

  return value
}

const getCertaintyStatus = (ann) => {
  const value = normalizeCertaintyValue(ann)

  if (value === null || value === undefined || value === '') return UNKNOWN_CERTAINTY_STATUS
  if (mosquitoStatus[value]) return mosquitoStatus[value]

  const normalizedLabel = String(value).trim().toUpperCase().replaceAll('_', ' ')
  const status = Object.values(mosquitoStatus).find(({ label }) => label === normalizedLabel)

  return status || UNKNOWN_CERTAINTY_STATUS
}

const getCertaintyPriority = (ann) => {
  const { label } = getCertaintyStatus(ann)

  return certaintyOrder[label] ?? 0
}

export {
  getCertaintyPriority,
  getCertaintyStatus,
}
